import { render, staticRenderFns } from "./DhcpTable.vue?vue&type=template&id=40f4fe5f&scoped=true&"
import script from "./DhcpTable.vue?vue&type=script&lang=js&"
export * from "./DhcpTable.vue?vue&type=script&lang=js&"
import style0 from "./DhcpTable.vue?vue&type=style&index=0&id=40f4fe5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f4fe5f",
  null
  
)

export default component.exports